import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    howTo: {
      caption:
        'If necessary, you will be put in contact with our debt recovery partner service.',
      content: [
        'A team of lawyers is available over the phone to answer any questions related to outstanding payments from your customers and the recovery of your invoices. They can be contacted Monday to Saturday between 9am and 6pm.',
        'Just call the freephone number below:',
      ],
      phoneNumber: '+33\xa04\xa011\xa062\xa000\xa075',
      title: 'How does it work?',
    },
    include: {
      items: [
        'A team of lawyers is available over the phone to answer any questions related to outstanding payments from your customers and the recovery of your invoices.',
        'They can be contacted Monday to Saturday between 9am and 6pm.',
      ],
      title: 'This coverage includes',
    },
    similarOffersTitle: 'Other insurances related to your coverage',
    title: 'Recovery assistance',
  },
  fr: {
    howTo: {
      caption:
        'En cas de besoin, vous serez mis en relation avec notre service partenaire de recouvrement de créances.',
      content: [
        'Une équipe de juristes répond par téléphone à toutes vos questions liées à des impayés de vos client·es et au recouvrement de vos factures. Vous pouvez les contacter du lundi au samedi entre 9h et 18h.',
        "Il suffit d'appeler le numéro gratuit ci-dessous\xa0:",
      ],
      phoneNumber: '+33\xa04\xa011\xa062\xa000\xa075',
      title: 'Comment ca marche\xa0?',
    },
    include: {
      items: [
        'Une équipe de juristes répond par téléphone à toutes vos questions liées à des impayés de vos client·es et au recouvrement de vos factures.',
        'Vous pouvez les contacter du lundi au samedi entre 9h et 18h.',
      ],
      title: 'Cette garantie inclut',
    },
    similarOffersTitle: 'Autres assurances liées à votre couverture',
    title: 'Assistance recouvrement',
  },
} as const);

export default locales;
